import type { NavbarGroupItemLevelType } from '@/business-components/navbar-group/NavbarGroup';
import {
  NavbarGroupLevel,
  NavbarGroupType,
} from '@/business-components/navbar-group/type/NavbarGroupTypeLevel';
import type { Navigation } from '@/shared/constant/navigation/Navigation';
import { NavigationTypeEnum } from '@/shared/constant/navigation/Navigation';
import React from 'react';

export function useLevelNavbarGroup(navigation: Navigation) {
  const firstLevelNavbarGroup = React.useMemo(() => {
    if (navigation.type === NavigationTypeEnum.None) {
      return undefined;
    }

    const result: NavbarGroupItemLevelType = {
      type: NavbarGroupType.Default,
      level: NavbarGroupLevel.Level1,
      items: navigation.firstLevelNavbarItems,
      align: navigation.align,
    };

    return result;
  }, [navigation]);

  const secondLevelNavbarGroup = React.useMemo(() => {
    if (navigation.type === NavigationTypeEnum.SecondLevelNavigation) {
      const result: NavbarGroupItemLevelType = {
        type: NavbarGroupType.LineTab,
        level: NavbarGroupLevel.Level2,
        items: navigation.secondLevelNavbarItems,
      };

      return result;
    } else if (navigation.type === NavigationTypeEnum.ThirdLevelNavigation) {
      const result: NavbarGroupItemLevelType = {
        type: NavbarGroupType.Select,
        level: NavbarGroupLevel.Level2,
        items: navigation.secondLevelNavbarItems,
      };

      return result;
    }
    return undefined;
  }, [navigation]);

  const thirdLevelNavbarGroup = React.useMemo(() => {
    if (navigation.type !== NavigationTypeEnum.ThirdLevelNavigation) {
      return undefined;
    }

    const result: NavbarGroupItemLevelType = {
      type: NavbarGroupType.LineTab,
      level: NavbarGroupLevel.Level3,
      items: navigation.thirdLevelNavbarItems,
    };

    return result;
  }, [navigation]);

  return {
    firstLevelNavbarGroup,
    secondLevelNavbarGroup,
    thirdLevelNavbarGroup,
  };
}
